<template>
    <div>
        <img src="../assets/img/fanhui.png" alt="" class="fanhuiBtn" @click="fanhui">
        <Swiper :swiperImg="swiperImg"></Swiper>
        <div class="jiudianjieshao">
            <p class="logo">
                <img src="../assets/img/Junlan/logo.png" alt="">
            </p>
            <p class="oneImg">
                <video src="../assets/video/junlan.mp4" controls poster="../assets/img/Junlan/fengmian.png"
                    x5-video-player-type="h5" x5-video-orientation="h5"></video>
            </p>
            <p class="wenzijieshao">
                隽蘭酒店是山东文旅酒店集团旗下度假酒店及精品民宿。隽蘭将自然、人文和居住完美的融为一体。体验一方水土的文化沉淀和自然脉络，更近距离感受城市的美，葳蕤的竹林、生长的兰花、愉悦的鸟鸣、充足的阳光，为宾客呈现更立体的全新旅宿体验。隽蘭，向美而居。
            </p>
            <p class="manxiang">
                <img src="../assets/img/Junlan/yuan.png" alt="">
                <span>隽蘭，向美而居</span>
            </p>
            <div class="photoZhanshi">
                <img src="../assets/img/Junlan/wenzi.png" alt="" class="gaoduan">
                <div class="shishangpinzhi">
                    <div>
                        <img src="../assets/img/Junlan/wenzi1.png" alt="">
                    </div>
                    <div>
                        <img src="../assets/img/Junlan/wenzi2.png" alt="">
                    </div>
                </div>
                <img src="../assets/img/Junlan/4.png" alt="" class="shengyu">
                <img src="../assets/img/Junlan/5.png" alt="" class="shengyu">
                <img src="../assets/img/Junlan/6.png" alt="" class="shengyu lastImg">
            </div>
        </div>
        <div class="jiamengyaoqiu">
            <p class="wuyeyaoqiu">隽蘭度假酒店物业要求</p>
            <ul class="wuyejuti">
                <li>
                    <span>单房投资</span>
                    <span>新建店：15万/间起</span>
                </li>
                <li>
                    <span>房量</span>
                    <span>≥60间</span>
                </li>
                <li>
                    <span>项目面积</span>
                    <span>不小于4000㎡</span>
                </li>
                <li>
                    <span>大堂净面积</span>
                    <span>不小于180㎡</span>
                </li>
                <li>
                    <span>客房净面积</span>
                    <span>大于40㎡</span>
                </li>
                <li>
                    <span>餐厅净面积</span>
                    <span>房间数*0.6*2.5</span>
                </li>
                <li class="juda">
                    <span>厨房净面积</span>
                    <span>不小于30㎡（景区度假酒店需配一个全日餐厅）</span>
                </li>
                <li>
                    <span>电梯</span>
                    <span>100间以下不少于一部专用100至140间，不少于两部专用；140以上，不少于三部专用</span>
                </li>
            </ul>
            <p class="wuyeyaoqiu">隽蘭度假民宿物业要求</p>
            <ul class="wuyejuti">
                <li class="juda">
                    <span>单房投资</span>
                    <span>新建店：15万/间起<br>改造店：1.5-3万/间</span>
                </li>
                <li>
                    <span>房量</span>
                    <span>60间＞房间数≥15间</span>
                </li>
                <li>
                    <span>项目面积</span>
                    <span>不小于1000㎡</span>
                </li>
                <li>
                    <span>大堂净面积</span>
                    <span>不小于30㎡</span>
                </li>
                <li>
                    <span>客房净面积</span>
                    <span>大于30㎡</span>
                </li>
                <li class="juda">
                    <span>餐厅净面积</span>
                    <span>低于40间（不含）不做强制，40间以上房间数*0.6*2.5</span>
                </li>
                <li>
                    <span>厨房净面积</span>
                    <span>不小于30㎡</span>
                </li>
                <li>
                    <span>电梯</span>
                    <span>三层（含三层）及以上一部专用电梯（必备）</span>
                </li>
            </ul>
            <p class="jiamengzhengce">隽蘭度假酒店加盟政策</p>
            <ul class="zhengcejuti">
                <li>
                    <span>加盟期限</span>
                    <span>10年</span>
                </li>
                <li>
                    <span>品牌加盟费</span>
                    <span>3500元/间</span>
                </li>
                <li>
                    <span>运营保证金</span>
                    <span>5万</span>
                </li>
                <li>
                    <span>品牌持续使用费</span>
                    <span>按酒店总收入3%收取</span>
                </li>
                <li class="juda">
                    <span>服务支持费</span>
                    <span>1.月出租率40%(不含)以下的,免收<br>2.月出租率40%(含)-60%(不含)之间的,按照酒店总收入的1%收取<br>3.月出租率60%(含)-80%(不含)之间的,按照酒店总收入的1.5%收取<br>4.月出租率80%(含)以上的,按照酒店总收入的2%收取</span>
                </li>
                <li class="juda">
                    <span>店长派驻费</span>
                    <span>按城市级别及房量确定每个月店长费用</span>
                </li>
                <li>
                    <span>工程督导费</span>
                    <span>3万元/店</span>
                </li>
                <li class="juda">
                    <span>系统初装及维护费</span>
                    <span>初装费1.8万元，维护费1500元/月（含AI智能管家）。</span>
                </li>
                <li>
                    <span>直销系统费用</span>
                    <span>7%</span>
                </li>
            </ul>
            <p class="jiamengzhengce">隽蘭民宿酒店加盟政策</p>
            <ul class="zhengcejuti">
                <li>
                    <span>加盟期限</span>
                    <span>10年</span>
                </li>
                <li>
                    <span>品牌加盟费</span>
                    <span>3500元/间</span>
                </li>
                <li>
                    <span>运营保证金</span>
                    <span>3万</span>
                </li>
                <li>
                    <span>品牌持续使用费</span>
                    <span>按酒店总收入3%收取</span>
                </li>
                <li class="juda">
                    <span>服务支持费</span>
                    <span>1.月出租率40%(不含)以下的,免收<br>2.月出租率40%(含)-60%(不含)之间的,按照酒店总收入的1%收取<br>3.月出租率60%(含)-80%(不含)之间的,按照酒店总收入的1.5%收取<br>4.月出租率80%(含)以上的,按照酒店总收入的2%收取</span>
                </li>
                <li class="juda">
                    <span>店长派驻费</span>
                    <span>按城市级别及房量确定每个月店长费用</span>
                </li>
                <li class="juda">
                    <span>工程督导费</span>
                    <span>新建店：3万元/店<br>改造店：0.5万元/店</span>
                </li>
                <li class="juda">
                    <span>系统初装及维护费</span>
                    <span>初装费1.8万元，维护费1500元/月（含AI智能管家）。</span>
                </li>
                <li>
                    <span>直销系统费用</span>
                    <span>7%</span>
                </li>
            </ul>
            <p class="tishi">特别提示：市场有风险，投资需谨慎</p>
            <div class="rexian">
                <p>135-1531-0068</p>
            </div>
            <div class="jiamengBtn">
                <button @click="jumpJoin">我要加盟</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            swiperImg: {
                url1: require('../assets/img/Junlan/one.png'),
                url2: require('../assets/img/Junlan/two.png'),
                url3: require('../assets/img/Junlan/three.png'),
                url4: require('../assets/img/Junlan/four.png'),
                url5: require('../assets/img/Junlan/five.png')
            }
        }
    },
    mounted() {

    },
    methods: {
        fanhui() {
            this.$router.go(-1)
        },
        jumpJoin() {
            let object = {
                banner: require('../assets/img/Join/junlan.png'),
                yingwen: require('../assets/img/Join/junlan1.png'),
                name: 'junlan',
                rexian: '135-1531-0068'
            }
            sessionStorage.setItem('message', JSON.stringify(object))
            this.$router.push({ path: '/Join' })
        }
    }
}
</script>

<style lang="less" scoped>
p {
    margin: 0;
}

.fanhuiBtn {
    z-index: 1000;
    position: absolute;
    width: 48px;
    height: 48px;
    top: 20px;
    left: 20px;
}

.jiudianjieshao {
    margin: 0 30px;
    height: auto;
    padding: 0 51.5px;
    position: relative;
    margin-top: -70px;
    background-color: #ffffff;
    box-shadow: -2px -3px 16px 0px rgba(149, 127, 102, 0.33),
        3px 3px 16px 0px rgba(149, 127, 102, 0.32);
    border-radius: 10px;
    z-index: 1000;

    .logo {
        text-align: center;
        padding-top: 24px;

        img {
            width: 97px;
            height: 100px;
        }
    }

    .oneImg {
        text-align: center;
        margin-top: 24px;
        margin-bottom: 35px;

        video {
            width: 100%;
            height: 331px;
        }
    }

    .wenzijieshao {
        text-indent: 2em;
        font-family: 'pfzd';
        font-size: 28px;
        letter-spacing: 1px;
        color: #000000;
        margin-bottom: 35px;
    }

    .manxiang {
        text-align: center;
        margin-bottom: 27px;

        img {
            width: 28px;
            height: 28px;
            position: relative;
            top: -15px;
            left: 10px;
        }

        span {
            font-family: 'pfzd';
            font-size: 35px;
            color: #b28247;
            text-shadow: -1px -1px 0px #b28247, -1px -1px 0px #b28247;
        }
    }

    .photoZhanshi {
        .gaoduan {
            width: 100%;
        }

        .shishangpinzhi {
            margin-top: 19px;

            div {
                width: 50%;
                display: inline-block;

                img {
                    width: 282px;
                    height: 245px;
                }
            }

            div:first-child {
                text-align: left;
            }

            div:last-child {
                text-align: right;
            }
        }

        .shengyu {
            width: 100%;
            margin-top: 20px;
        }

        .lastImg {
            padding-bottom: 67px;
        }
    }
}

.jiamengyaoqiu {
    padding: 0 30px;

    .wuyeyaoqiu {
        font-family: 'pfzd';
        font-size: 40px;
        color: #b28247;
        text-align: center;
        margin-top: 38px;
    }

    .wuyejuti {
        width: 100%;
        margin-top: 40px;

        li {
            padding: 0 21px;
            height: 69px;
            display: flex;
            align-items: center;

            span {
                display: inline-block;
                vertical-align: middle;
                font-family: 'pfzd';
                font-size: 26px;
                letter-spacing: 0px;
                color: #9a9954;
            }

            span:first-child {
                width: 51.5%;
            }

            span:last-child {
                width: 48.5%;
            }
        }

        li:nth-of-type(odd) {
            background-color: #f2f2f2;
        }

        .juda {
            height: auto;
            padding: 25px 21px;
        }

        li:last-child {
            height: auto;
            margin-top: 27px;

            span:last-child {
                line-height: 35px;
            }
        }
    }

    .jiamengzhengce {
        font-family: 'pfzd';
        font-size: 40px;
        line-height: 69px;
        color: #b28247;
        text-align: center;
        margin-top: 35px;
    }

    .zhengcejuti {
        width: 100%;
        height: auto;
        margin-top: 33px;

        li {
            padding: 0 21px;
            height: 69px;
            display: flex;
            align-items: center;

            span {
                display: inline-block;
                vertical-align: middle;
                font-family: 'pfzd';
                font-size: 26px;
                letter-spacing: 0px;
                color: #9a9954;
            }

            span:first-child {
                width: 51.5%;
            }

            span:last-child {
                width: 48.5%;
            }
        }

        li:nth-of-type(odd) {
            background-color: #f2f2f2;
        }

        .juda {
            height: auto;
            padding: 25px 21px;
        }
    }

    .tishi {
        text-align: center;
        font-family: 'pfct';
        font-size: 32px;
        line-height: 69px;
        color: #9a9954;
        margin-bottom: 59px;
        margin-top: 54px;
    }

    .rexian {
        width: 580px;
        height: 114px;
        margin: 0 auto;
        background-image: url(../assets/img/Junlan/jiameng.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        text-align: center;

        p {
            font-family: 'pfct';
            font-size: 50px;
            letter-spacing: 3px;
            color: #b28247;
            margin: 0 auto;
            margin-top: 20px;
        }
    }

    .jiamengBtn {
        text-align: center;
        margin-top: 62px;
        margin-bottom: 80px;

        button {
            width: 583px;
            height: 80px;
            background-color: #b28247;
            border-radius: 10px;
            color: #ffffff;
            font-family: 'pfct';
            font-size: 32px;
            letter-spacing: 6px;
            border: none;
        }
    }
}
</style>
